import { render, staticRenderFns } from "./BlondWaiting2.vue?vue&type=template&id=dd3ef034&"
import script from "./BlondWaiting2.vue?vue&type=script&lang=ts&"
export * from "./BlondWaiting2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports